var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555F6D",
    fillRule: "evenodd",
    d: "M9.491 1.199a.75.75 0 0 1 1.018 0l3.25 3A.75.75 0 1 1 12.74 5.3L10.75 3.463v8.787a.75.75 0 0 1-1.5 0V3.463L7.259 5.301A.75.75 0 1 1 6.24 4.2zM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 1.5 0v2.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgUpload;